module.exports = __webpack_public_path__ + "images/orion_reed.jpg?v=a9e33b0be875e31e125e96d41d08e678";